import { Component } from '@angular/core';

@Component({
  selector: 'rtr-sign-in-button',
  templateUrl: './sign-in-button.component.html',
  styleUrls: ['./sign-in-button.component.less'],
})
export class SignInButtonComponent {}
